import { createSlice } from '@reduxjs/toolkit';
import {userOtpVerificationApi} from '../LoginApi/loginApi';

const otpVerificationSlice = createSlice({
  name: 'otpVerification',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(userOtpVerificationApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userOtpVerificationApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(userOtpVerificationApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default otpVerificationSlice.reducer;
